import {
  FETCH_ENROLLMENT_SETTINGS_BEGIN,
  FETCH_ENROLLMENT_SETTINGS_SUCCESS,
  FETCH_ENROLLMENT_SETTINGS_ERROR,
  FETCH_ENROLLMENT_DETAILS_BEGIN,
  FETCH_ENROLLMENT_DETAILS_SUCCESS,
  FETCH_ENROLLMENT_DETAILS_ERROR,
  CHANGE_PLAN,
  CHANGE_INTERVAL_OPTION,
  CHANGE_MEMBER_SELECTION,
  CHANGE_MEMBER_GROUP,
  FETCH_ENROLLMENT_PREVIEW_BEGIN,
  FETCH_ENROLLMENT_PREVIEW_SUCCESS,
  FETCH_ENROLLMENT_PREVIEW_ERROR,
  SAVE_ENROLLMENT_BEGIN,
  SAVE_ENROLLMENT_SUCCESS,
  SAVE_ENROLLMENT_ERROR,
  CHECKOUT_ENROLLMENT_BEGIN,
  CHECKOUT_ENROLLMENT_SUCCESS,
  CHECKOUT_ENROLLMENT_ERROR,
  TOGGLE_PANEL,
  TOGGLE_SHOW_MORE,
  VALIDATE_ENROLLMENT_BEGIN,
  VALIDATE_ENROLLMENT_SUCCESS,
  VALIDATE_ENROLLMENT_ERROR,
  CLEAR_ENROLLMENT_ERROR,
} from "actions/enrollmentActions";
import {
  initEnrollmentDetail,
  updateBenefitsForPlanChange,
  updateBenefitsForIntervalOptionChange,
  updateBenefitsForMemberSelectionChange,
  updateBenefitsForMemberGroupChange,
  updateBenefitsForPanelToggle,
  updateBenefitsForShowMoreToggle,
  updateStepsBasedOnEnrollmentDetail,
  buildBenefitMap,
} from "../components/employee/shop/EnrollmentDataUtil";
const initialState = {
  settings: null,
  details: null,
  benefitMap: {},
  preview: null,
  isFetching: false,
  isSaving: false,
  isDirty: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ENROLLMENT_SETTINGS_BEGIN:
    case FETCH_ENROLLMENT_DETAILS_BEGIN:
    case FETCH_ENROLLMENT_PREVIEW_BEGIN:
    case VALIDATE_ENROLLMENT_BEGIN:
      return { ...state, isFetching: true };
    case FETCH_ENROLLMENT_SETTINGS_ERROR:
    case FETCH_ENROLLMENT_DETAILS_ERROR:
    case FETCH_ENROLLMENT_PREVIEW_ERROR:
    case VALIDATE_ENROLLMENT_ERROR:
      return { ...state, isFetching: false, error: action.payload };
    case SAVE_ENROLLMENT_BEGIN:
    case CHECKOUT_ENROLLMENT_BEGIN:
      return { ...state, isSaving: true };
    case SAVE_ENROLLMENT_ERROR:
    case CHECKOUT_ENROLLMENT_ERROR:
      return { ...state, isSaving: false, error: action.payload };
    case FETCH_ENROLLMENT_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...action.payload,
          enrolmentPages: state.details
            ? updateStepsBasedOnEnrollmentDetail(state.details, [
                ...action.payload.enrolmentPages
              ])
            : [
                ...(action.payload.enrolmentPages || [])
              ],
        },
        isFetching: false,
      };
    case FETCH_ENROLLMENT_DETAILS_SUCCESS:
      return {
        ...state,
        details: initEnrollmentDetail(action.payload),
        benefitMap: buildBenefitMap(action.payload),
        settings: {
          ...state.settings,
          enrolmentPages: updateStepsBasedOnEnrollmentDetail(
            action.payload,
            state.settings.enrolmentPages
          ),
        },
        isFetching: false,
        isDirty: false,
      };
    case FETCH_ENROLLMENT_PREVIEW_SUCCESS:
      return {
        ...state,
        preview: action.payload,
        isFetching: false,
      };
    case CHANGE_PLAN:
      return {
        ...state,
        details: updateBenefitsForPlanChange(
          state.details,
          action.payload.benefitID,
          action.payload.selectedPlan
        ),
        isFetching: false,
        isDirty: true,
      };
    case CHANGE_INTERVAL_OPTION:
      return {
        ...state,
        details: {
          ...updateBenefitsForIntervalOptionChange(
            state.details,
            action.payload.plan,
            action.payload.benefitId,
            action.payload.optionId
          ),
        },
        isFetching: false,
        isDirty: true,
      };
    case CHANGE_MEMBER_SELECTION:
      return {
        ...state,
        details: {
          ...updateBenefitsForMemberSelectionChange(
            state.details,
            action.payload.plan,
            action.payload.benefitId,
            action.payload.memberKey,
            action.payload.memberType,
          ),
        },
        isFetching: false,
        isDirty: true,
      };
    case CHANGE_MEMBER_GROUP:
      return {
        ...state,
        details: {
          ...updateBenefitsForMemberGroupChange(
            state.details,
            action.payload.benefitId,
            action.payload.plan,
            action.payload.memberType
          ),
        },
        isFetching: false,
        isDirty: true,
      };
    case SAVE_ENROLLMENT_SUCCESS:
    case CHECKOUT_ENROLLMENT_SUCCESS:
      return { ...state, isSaving: false, isDirty: false , error: null,};
    case VALIDATE_ENROLLMENT_SUCCESS:
      return { ...state, isFetching: false, error: null };
    case TOGGLE_PANEL:
      return {
        ...state,
        details: updateBenefitsForPanelToggle(state.details, action.payload),
        isFetching: false,
      };
    case TOGGLE_SHOW_MORE:
      return {
        ...state,
        details: {
          ...updateBenefitsForShowMoreToggle(state.details, action.payload),
        },
        isFetching: false,
      };
    case CLEAR_ENROLLMENT_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/enrollmentReducer.js